// src/components/Loader.jsx
import React from "react";
import "./Loader.css"; 

const Loader = () => {
  return (
    <>
     {/* <div className="global-loader">
       <div className="spinner"></div>
     </div> */}

      <div class="preloader ">
         <button class="th-btn style3 preloaderCls">Cancel Preloader </button>
         <div class="preloader-inner">
             <span class="loader"></span>
         </div>
     </div>
     
</>
  );
};

export default Loader;
